import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "../component/Newsletter";

const Footer = () => {
  return (
    <div className="bg-[#5C4033] text-white p-6">
      <div className="flex flex-col lg:flex-row justify-evenly space-y-8 lg:space-y-0 lg:space-x-8 lg:px-10 lg:py-10">
        <div className="flex flex-col space-y-4 max-w-md">
          <img src="/logo/logo.jpeg"
            alt="Logo"
            className="w-[170px] h-auto"
          />
          <h1 className="text-xl font-semibold mt-3">Subscribe With Us</h1>
          <p>
            Sign up now and be the first to know <br />
            about new products, offers, and exciting updates.
          </p>
          <Newsletter />
        </div>

        <div className="flex flex-col lg:flex-row justify-between w-full lg:w-2/3 space-y-8 lg:space-y-0 lg:space-x-8">
          <div className="flex flex-col space-y-2">
            <h1 className="text-2xl font-semibold mb-2">Services</h1>
            <Link to="/gps-tracking" className="hover:underline">GPS Location Tracking</Link>
            <Link to="/it-management" className="hover:underline">IT Management Services</Link>
            <Link to="/digital-marketing" className="hover:underline">Digital Marketing</Link>
            <Link to="/guest-wifi" className="hover:underline">Guest Wi-Fi Management</Link>
            <Link to="/website-development" className="hover:underline">Website Development</Link>
            <Link to="/app-development" className="hover:underline">App Development</Link>
            <Link to="/data-digitization" className="hover:underline">Data Scanning & Digitization</Link>
            <Link to="/manpower-solution" className="hover:underline">Manpower Solution</Link>
          </div>

          <div className="flex flex-col space-y-2">
            <h1 className="text-2xl font-semibold mb-2">Policy</h1>
            <Link to="/refund-policy" className="hover:underline">Refund & Cancellation Policy</Link>
            <Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:underline">Terms & Conditions</Link>
            <Link to="/disclaimer" className="hover:underline">Disclaimer</Link>
          </div>

          <div className="flex flex-col space-y-2">
            <h1 className="text-2xl font-semibold mb-2">Explore</h1>
            <Link to="/contact" className="hover:underline">Contact Us</Link>
            <Link to="/career" className="hover:underline">Careers</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
